import Commands from './commands';

class Exists extends Commands {
    constructor(registry) {
        super("exists", registry);
    }

    async execute(node, emitter, options) {
        const key = await emitter(node.params[0], options);
        return this.registry.hasKey(key);
    }
}

export default Exists;
